import client from "../client";

const getStatus = () => client.get<any>("/surveys/status");
const submit = (data: any) => client.post<any>("/surveys", data);
const getReport = () => client.get<any>("/surveys/report");
const getReportForTrainers = () => client.get<any>("/surveys/report/for-trainers");

const surveyApi = {
  getStatus,
  submit,
  getReport,
  getReportForTrainers,
};
export default surveyApi;
